import React, { useRef } from "react";
import { useIntl, IntlShape } from "react-intl";
import { ProvisionalBody } from "../types";
import { LinkIcon } from "@heroicons/react/20/solid";
import Tooltip from "./Tooltip";
import CustomPopover from "./Popover";

// Le lien du post : url, titre, bouton d'action. Sa vignette n'est plus un média du body —
// elle sera récupérée à la volée (OG), comme le font les réseaux.
type Props = {
  body: ProvisionalBody;
  updateBody: (data: Object) => void;
  disabled?: boolean;
}
export const getCtaOptions = (intl: IntlShape) => [
  { label: intl.formatMessage({ id: "body_editor.cta_choose" }), value: undefined },
  { label: intl.formatMessage({ id: "body_editor.cta_order_now" }), value: "order_now" },
  { label: intl.formatMessage({ id: "body_editor.cta_shop_now" }), value: "shop_now" },
  { label: intl.formatMessage({ id: "body_editor.cta_learn_more" }), value: "learn_more" },
  { label: intl.formatMessage({ id: "body_editor.cta_sign_up" }), value: "sign_up" },
  { label: intl.formatMessage({ id: "body_editor.cta_call_now" }), value: "call_now" },
  { label: intl.formatMessage({ id: "body_editor.cta_contact_us" }), value: "contact_us" },
];

const BodyLink = ({ body, updateBody, disabled = false }: Props) => {
  const ref = useRef(null);
  const intl = useIntl();
  return (
    <CustomPopover button={
      <Tooltip text={intl.formatMessage({ id: "body_editor.insert_link", defaultMessage: "Insérer un lien" })}>
        <div className={`flex justify-center items-center text-brand_main bg-gray-100 rounded-full size-9 ${disabled ? "cursor-default" : " hover:bg-gray-200"}`}
        >
          <LinkIcon className={`size-6 ${disabled ? "text-gray-400 hover:text-gray-400" : "hover:text-brand_darker"}`} />
        </div>
      </Tooltip>
    }
      disabled={disabled}
      position="top"
      panelClasses="drop-shadow-sm"
    >
      <div className="z-10 p-4 bg-white my-auto relative rounded-md w-[400px] border" ref={ref}>
        <div className="flex flex-col justify-center h-full gap-4">
          <div className="flex flex-col gap-2 items-start w-full">
            <div className="flex w-full relative">
              <span className="absolute flex h-full w-auto px-3 items-center top-0 left-0 text-gray-500 text-sm bg-gray-200 border border-e-0 border-gray-300 rounded-l-md -mr-4">https://</span>
              <input
                type="text"
                id={`bodies[${body.provisional_id}][link_url]`}
                placeholder="example.com"
                value={body?.link_url?.replaceAll(/https?:\/\//g, "")}
                onChange={(event) => {
                  const path = event?.target?.value.replaceAll(/https?:\/\//g, "")
                  updateBody({ link_url: path ? "https://" + path : null }) // on re-remplace pour éviter les cas edgy
                }}
                className="flex flex-1 w-full border-gray-300 rounded-md shadow-sm focus:border-brand_focus focus:ring focus:ring-brand_focus focus:ring-opacity-20"
                style={{ paddingLeft: "5rem" }}

              />
            </div>
            <input
              type="text"
              id={`bodies[${body.provisional_id}][link_description]`}
              disabled={!body?.link_url}
              placeholder={intl.formatMessage({ id: "body_editor.link_description_placeholder", defaultMessage: "Description du lien" })}
              value={body?.link_description ?? ""}
              onChange={(event) => updateBody({ link_description: event.target.value })}
              className="custom-form-input w-full"
            />
            <select
              disabled={!body?.link_url}
              className="custom-form-input w-full"
              id={`bodies[${body.provisional_id}][link_cta]`}
              value={body?.link_cta || "Aucun"}
              onChange={(event) => updateBody({ link_cta: event.target.value })}
            >
              {getCtaOptions(intl).map((opt, index) => (
                <option key={`${opt.value}_${index}`} value={opt.value}>{opt.label}</option>
              ))}
            </select>

          </div>
        </div>
      </div>
    </CustomPopover>
  );
}

export default BodyLink;
